import React, { useState, useEffect } from 'react';
import JiboEye from './JiboEye';
import '../styles/Navbar.css';

const Navbar: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
      setMenuOpen(false);
    }
  };

  return (
    <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <div className="navbar__container">
        <div className="navbar__brand" onClick={() => scrollTo('hero')}>
          <JiboEye size={32} animated={false} />
          <span className="navbar__title">jibo.net</span>
        </div>
        <button
          className={`navbar__hamburger ${menuOpen ? 'navbar__hamburger--open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span />
          <span />
          <span />
        </button>
        <ul className={`navbar__links ${menuOpen ? 'navbar__links--open' : ''}`}>
          <li><button onClick={() => scrollTo('about')}>About</button></li>
          <li><button onClick={() => scrollTo('features')}>Features</button></li>
          <li><button onClick={() => scrollTo('timeline')}>Timeline</button></li>
          <li><button onClick={() => scrollTo('specs')}>Specs</button></li>
          <li><button onClick={() => scrollTo('goodbye')}>Goodbye</button></li>
          <li><button onClick={() => scrollTo('legacy')}>Legacy</button></li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
